import { render, staticRenderFns } from "./MyGroupBuy.vue?vue&type=template&id=a95b090e&scoped=true&"
import script from "./MyGroupBuy.vue?vue&type=script&lang=js&"
export * from "./MyGroupBuy.vue?vue&type=script&lang=js&"
import style0 from "./MyGroupBuy.vue?vue&type=style&index=0&id=a95b090e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a95b090e",
  null
  
)

export default component.exports